import { createTheme } from '@material-ui/core/styles';

const themeBase = {
  palette: {
    primary: {
      main: '#4a4a4a'
    },
    secondary: {
      main: '#ffffff'
    }
  },
  typography: {
    h1: {
      fontFamily: `"Visby CF", Arial`
    },
    h2: { fontFamily: `"Visby CF", Arial` },
    h3: { fontFamily: `"Visby CF", Arial` },
    h4: { fontFamily: `"Visby CF", Arial` },
    h5: { fontFamily: `"Visby CF", Arial` },
    h6: { fontFamily: `"Visby CF", Arial` },
    subtitle1: { fontFamily: `"Visby CF", Arial` },
    subtitle2: { fontFamily: `"Visby CF", Arial` },
    body1: { fontFamily: `"Visby CF", Arial` },
    body2: { fontFamily: `"Visby CF", Arial` },
    button: { fontFamily: `"Visby CF", Arial`, fontSize: '15px' },
    caption: { fontFamily: `"Visby CF", Arial` },
    overline: { fontFamily: `"Visby CF", Arial` }
  },
  overrides: {
    MuiInputBase: {
      root: {
        borderRadius: '0 !important'
      }
    },
    MuiFormHelperText: {
      root: {
        textAlign: 'right'
      }
    },
    MuiTextField: {
      root: {
        width: '100%',
        marginBottom: '1rem'
      }
    },
    MuiAccordion: {
      root: {
        margin: '0 !important',
        padding: '0 !important'
      }
    },
    MuiAccordionDetails: {
      root: {
        display: 'block'
      }
    }
  }
};

const palette13Cabs = {
  palette: {
    primary: {
      main: '#4a4a4a'
    },
    secondary: {
      main: '#f58200'
    }
  }
};

const paletteSilverService = {
  palette: {
    primary: {
      main: '#4a4a4a'
    },
    secondary: {
      main: '#2f57bc'
    }
  }
};

export const themeMappings = {
  default: createTheme(themeBase),
  '13cabs': createTheme(Object.assign(themeBase, palette13Cabs)),
  silver: createTheme(Object.assign(themeBase, paletteSilverService))
};
